export const environment = {
  production: true,
  apiUrl: 'https://api-dev.beech.cl',
  socketUrl: 'https://api-dev.beech.cl',
  backofficeUrl: 'https://backoffice-dev.beecher.cl',
  apiUrlFiles: 'https://api-dev.beech.cl/dashboard/obtener-imagen/',
  visorUrl: 'https://visor-dev.beech.cl',
};